module.exports = __webpack_public_path__ + "static/img/apple-app-download.efd777f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-app-download.png
// module id = X7Ul
// module chunks = 1